<template>
  <div class="warp">
    <div class="fn-page-container">
      <div class="fn-page-head">
        <h4>
          {{ "FW" + this.$route.query.ProjectNo }}
          <el-divider direction="vertical"></el-divider>外采信息
        </h4>
        <div>
          <el-button type="primary" icon="el-icon-plus" @click="add"
            >新增外采</el-button
          >
        </div>
      </div>
      <!-- table -->
      <div>
        <el-table
          v-loading="loading"
          :data="tableData"
          size="mini"
          :highlight-current-row="true"
          ref="acceptanceTable"
          empty-text="暂无验收信息"
        >
          <el-table-column label="审核" width="90">
            <template slot-scope="scope">
              <!-- 审核状态（0-未提交，1-已提交，2-审核通过，3-退回） -->
              <div v-if="scope.row.status === 0">
                <el-button type="text" @click="submitReview(scope.row, 1)"
                  >提交</el-button
                >
              </div>
              <div
                v-else-if="
                  scope.row.status === 1 &&
                  codes.indexOf('MIS2.0-outSourcing-manage-audit') >= 0
                "
              >
                <el-button type="text" @click="submitPass(scope.row, 2)"
                  >通过</el-button
                >
                <el-button type="text" @click="submitBack(scope.row, 3)"
                  >退回</el-button
                >
              </div>
              <div
                v-else-if="
                  scope.row.status === 2 &&
                  codes.indexOf('MIS2.0-outSourcing-manage-audit') >= 0
                "
              >
                <el-button type="text" @click="submitBack(scope.row, 3)"
                  >退回</el-button
                >
              </div>
              <div v-else-if="scope.row.status === 3">
                <el-button type="text" @click="submitReview(scope.row, 1)"
                  >提交</el-button
                >
              </div>
              <div v-else style="color: #c3c3c3">-</div>
            </template>
          </el-table-column>
          <el-table-column
            label="(外采)合同编号"
            prop="contractCode"
            width="120"
          ></el-table-column>
          <el-table-column
            label="(外采)合同名称"
            prop="contractName"
          ></el-table-column>
          <el-table-column
            label="(外采)合同金额"
            prop="contractPrice"
            width="120"
          ></el-table-column>
          <el-table-column
            label="实际成本"
            prop="actualCost"
            width="90"
          ></el-table-column>
          <el-table-column
            label="已付款金额"
            prop="paymentAmount"
            width="100"
          ></el-table-column>
          <el-table-column
            label="项目经理"
            prop="projectManager"
            width="80"
          ></el-table-column>
          <el-table-column
            label="售后"
            prop="afterSale"
            width="60"
          ></el-table-column>
          <el-table-column label="性质" width="60">
            <template slot-scope="scope">
              {{
                scope.row.contractType === 152
                  ? "新签"
                  : scope.row.contractType === 153
                  ? "续约"
                  : scope.row.contractType === 154
                  ? "终止"
                  : "补充"
              }}
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              服务时间
              <el-tooltip
                class="item"
                effect="dark"
                content="我方跟第三方公司签订合同中规定的服务时间"
                placement="top"
              >
                <el-button
                  icon="el-icon-question"
                  type="text"
                  size="medium"
                ></el-button>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span>
                {{ formatDate(scope.row.serviceStartDate) }} 至
                {{ formatDate(scope.row.serviceEndDate) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="DAM附件" width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.damFilePath">
                <a :href="scope.row.damFilePath">附件下载</a>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" width="90">
            <template slot-scope="scope">
              <!-- 审核状态（0-未提交，1-已提交，2-审核通过，3-退回） -->
              <el-tag
                size="medium"
                :type="
                  scope.row.status === 0
                    ? 'warning'
                    : scope.row.status === 1
                    ? ''
                    : scope.row.status === 2
                    ? 'success'
                    : 'danger'
                "
                >{{
                  scope.row.status === 0
                    ? "未提交"
                    : scope.row.status === 1
                    ? "已提交"
                    : scope.row.status === 2
                    ? "审核通过"
                    : "退回"
                }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="审核人" prop="audit" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.status > 1">
                {{ scope.row.auditName }}</span
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="(MIS)使用状态" width="120">
            <template slot-scope="scope">
              {{ scope.row.taskID === 0 ? "未使用" : "已使用" }}
            </template></el-table-column
          >
          <el-table-column label="(MIS)营收成本统计" width="140">
            <template slot-scope="scope">
              {{ scope.row.isCost === 0 ? "未使用" : "已使用" }}
            </template></el-table-column
          >
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit-outline"
                @click="handleEdit(scope.row, scope.$index)"
                >编辑</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button
                type="text"
                icon="el-icon-coin"
                @click="paymentOpen(scope.row)"
                >付款信息</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="handleDel(scope.row, scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageCurrent"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableTotalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增/编辑外采 -->
    <el-dialog
      :title="ExternalTitle"
      :visible.sync="addExternalDialog"
      width="600px"
      @close="resetForm('ruleForm')"
    >
      <div style="margin: 0 -20px">
        <el-scrollbar ref="hotScroll" style="height: calc(100vh - 428px)">
          <el-form
            ref="ruleForm"
            :model="ruleForm"
            :rules="rules"
            label-position="right"
            label-width="100px"
            size="medium"
            style="padding: 0 40px"
          >
            <el-form-item label="合同编号" prop="ContractCode">
              <el-input
                v-model="ruleForm.ContractCode"
                placeholder="请输入合同编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="合同名称" prop="ContractName">
              <el-input
                v-model="ruleForm.ContractName"
                placeholder="请输入合同名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="合同金额" prop="ContractPrice">
              <el-input
                v-model.number="ruleForm.ContractPrice"
                placeholder="请输入合同金额（元）"
              ></el-input>
            </el-form-item>
            <el-form-item label="实际成本" prop="ActualCost">
              <el-input
                v-model.number="ruleForm.ActualCost"
                placeholder="请输入实际成本（元）"
              ></el-input>
            </el-form-item>
            <el-form-item label="供应商名称" prop="SupplierName">
              <el-input
                v-model="ruleForm.SupplierName"
                placeholder="请输入供应商名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="付款方式" prop="Payment">
              <el-input
                v-model="ruleForm.Payment"
                placeholder="请输入付款方式"
              ></el-input>
            </el-form-item>
            <el-form-item label="合同性质" prop="ContractType">
              <el-select
                @change="changeValue"
                v-model="ruleForm.ContractType"
                placeholder="请选择合同性质"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item.dictionaryName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签订时间" prop="SignDate">
              <el-date-picker
                type="date"
                placeholder="请输入签订时间"
                v-model="ruleForm.SignDate"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="服务时间" prop="ServiceDate">
              <el-date-picker
                v-model="ruleForm.ServiceDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="服务结束时间" prop="ServiceEndDate">
              <el-input
                v-model="ruleForm.ServiceEndDate"
                placeholder="请输入服务结束时间"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="售后" prop="AfterSale">
              <el-input
                v-model="ruleForm.AfterSale"
                placeholder="请输入售后"
              ></el-input>
            </el-form-item>
            <el-form-item label="项目经理" prop="ProjectManager">
              <el-input
                v-model="ruleForm.ProjectManager"
                placeholder="请输入项目经理"
              ></el-input>
            </el-form-item>
            <el-form-item label="服务内容" prop="ServiceContent">
              <el-input
                v-model="ruleForm.ServiceContent"
                placeholder="请输入服务内容"
              ></el-input>
            </el-form-item>

            <el-form-item label="备注" prop="Remark">
              <el-input
                v-model="ruleForm.Remark"
                placeholder="请输入备注信息"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传的附件" :prop="isNew ? 'fileList' : ''">
              <div
                style="font-size: 12px; line-height: 24px; margin-top: 6px"
                v-if="!newCreateBtn && ruleForm.DAMFilePath"
              >
                <div>已有附件：{{ ruleForm.DAMFilePath | fileNameReduce }}</div>
                <div class="text-warning">
                  <i class="el-icon-warning"></i>
                  重新选择上传附件，将替换已有附件，请谨慎操作！
                </div>
              </div>
              <el-upload
                class="upload-demo"
                action=""
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :on-change="fileChange"
                :auto-upload="false"
                :file-list="ruleForm.fileList"
                accept=".doc,.docx,.pdf"
              >
                <div slot="tip" class="el-upload__tip">
                  请选择 word/pdf 文件上传
                </div>
                <el-button size="small" type="primary" icon="el-icon-upload2"
                  >选择附件</el-button
                >
              </el-upload>
            </el-form-item>
          </el-form>
        </el-scrollbar>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button
          type="primary"
          :loading="addLoading"
          @click="submitForm('ruleForm')"
          v-if="newCreateBtn"
          >确认新增</el-button
        >
        <el-button type="primary" @click="submitFormEdit('ruleForm')" v-else
          >确认编辑</el-button
        >
      </span>
    </el-dialog>

    <!-- 付款信息 -->

    <el-dialog
      :title="paymentTitle + '-付款信息'"
      :visible.sync="PaymentDialog"
      width="700px"
    >
      <el-dialog
        width="30%"
        title="新增付款"
        :visible.sync="PaymentAdd"
        append-to-body
        @close="resetPaymentForm('ruleForm')"
      >
        <div>
          <el-form
            ref="PaymentForm"
            :model="PaymentForm"
            :rules="PaymentRules"
            label-position="right"
            label-width="100px"
            size="medium"
            style="padding: 0 40px"
          >
            <el-form-item label="付款金额" prop="paymentAmount">
              <el-input
                v-model.number="PaymentForm.paymentAmount"
                placeholder="请输入付款金额"
              ></el-input>
            </el-form-item>
            <el-form-item label="付款时间" prop="paymentDate">
              <el-date-picker
                type="date"
                placeholder="请输入付款时间"
                v-model="PaymentForm.paymentDate"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="付款情况" prop="paymentSituation">
              <el-select
                @change="changePaymentValue"
                v-model="PaymentForm.paymentSituation"
                placeholder="请选择付款情况"
              >
                <el-option
                  v-for="(item, index) in paymentOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                rows="2"
                v-model="PaymentForm.remark"
                placeholder="请输入备注信息"
              ></el-input>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            class="dialog-footer"
            style="width: 100%; text-align: right"
          >
            <el-button @click="resetPaymentForm('PaymentForm')"
              >取 消</el-button
            >
            <el-button
              type="primary"
              :loading="addLoading"
              @click="submitPaymentForm('PaymentForm')"
              >确认新增</el-button
            >
          </div>
        </div>
      </el-dialog>
      <div class="dialog-title">
        <h6>付款信息列表</h6>
        <el-button type="primary" @click="PaymentAdd = true" icon="el-icon-plus"
          >新增付款信息</el-button
        >
      </div>

      <div class="paymentInfo">
        <el-table
          :data="paymentTableData"
          size="mini"
          :highlight-current-row="true"
          ref="paymentTableData"
        >
          <el-table-column
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column
            label="付款金额"
            prop="paymentAmount"
            width="100px"
          ></el-table-column>
          <el-table-column label="付款时间" width="100px">
            <template slot-scope="scope">
              <span>{{ formatDate(scope.row.paymentDate) }} </span></template
            >
          </el-table-column>
          <el-table-column
            label="付款情况"
            prop="paymentSituation"
            width="100px"
          ></el-table-column>
          <el-table-column label="备注" prop="remark"></el-table-column>
          <el-table-column label="操作" width="80px">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="delPaymentInfo(scope.row, scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import eventBus from "@/pages/EventBus";
import {
  AduitOutSourcingManagement,
  EditOutSourcingManagement,
  AddOutSourcingManagement,
  GetOutSourcingManagementPageList,
  DeletetOutSourcingManagement,
  GetOutSourcingtPaymentPageList,
  PaymentAdd,
  GetListByType,
  OutSourcingPaymentDelete
} from "@/api/AcceptanceCheckManagement.js";

import moment from "moment";

export default {
  computed: {
    ...mapGetters(["userName", "user", "codes"])
  },
  data() {
    return {
      addLoading: false,

      loading: false,
      addExternalDialog: false,
      PaymentDialog: false,

      // 外采合同列表
      ExternalTitle: "新增外采",
      pageCurrent: 1,
      pageLimit: 10,
      tableTotalCount: 0,
      paymentTableData: [],
      tableData: [],
      newCreateBtn: true,
      isNew: true,

      PaymentAdd: false,

      searchForm: {},
      options: [],
      ruleForm: {
        ContractCode: "",
        ContractName: "",
        ContractPrice: "",
        ActualCost: "",
        SupplierName: "",
        Payment: "",
        ContractType: "",
        SignDate: "",
        ServiceDate: "",
        AfterSale: "",
        ProjectManager: "",
        ServiceContent: "",
        Remark: "",
        fileList: []
      },
      rules: {
        ContractCode: [
          { required: true, message: "请输入合同编号", trigger: "blur" },
          { min: 2, max: 50, message: "长度在 2 到 50 个字符", trigger: "blur" }
        ],
        ContractName: [
          { required: true, message: "请输入合同名称", trigger: "blur" }
        ],
        ContractPrice: [
          { required: true, message: "请输入合同金额" },
          { type: "number", message: "合同金额必须为数字值" }
        ],
        ActualCost: [
          { required: true, message: "请输入实际成本" },
          { type: "number", message: "实际成本必须为数字值" }
        ],
        SupplierName: [
          { required: true, message: "请输入供应商名称", trigger: "blur" }
        ],
        ContractType: [
          { required: true, message: "请选择合同性质", trigger: "blur" }
        ],
        SignDate: [
          {
            type: "date",
            required: true,
            message: "请选择签订日期",
            trigger: "change"
          }
        ],
        ServiceDate: [
          {
            type: "array",
            required: true,
            message: "请选择服务日期区间",
            // trigger: "change"
            fields: {
              // tpye类型试情况而定,所以如果返回的是date就改成date
              0: { type: "date", required: true, message: "请选择开始日期" },
              1: { type: "date", required: true, message: "请选择结束日期" }
            }
          }
        ],
        fileList: [
          {
            required: true,
            message: "请选择上传附件",
            trigger: "change"
          }
        ]
      },

      // 付款情况
      paymentTitle: "付款信息",
      PaymentForm: {
        paymentAmount: "",
        anchorpaymentDate: ""
      },
      paymentOptions: [
        { id: 1, label: "第一笔" },
        { id: 2, label: "第二笔" },
        { id: 3, label: "第三笔" },
        { id: 4, label: "第四笔" },
        { id: 5, label: "第五笔" },
        { id: 6, label: "第六笔" }
      ],
      PaymentRules: {
        paymentAmount: [
          { required: true, message: "请输入合同金额" },
          { type: "number", message: "合同金额必须为数字值" }
        ],
        paymentDate: [
          {
            type: "date",
            required: true,
            message: "请选择付款日期",
            trigger: "change"
          }
        ],
        paymentSituation: [
          { required: true, message: "请选择付款情况", trigger: "blur" }
        ]
      }
    };
  },
  activated() {},
  watch: {},
  created() {},
  mounted() {
    eventBus.$emit("MenuStatus", false); // 隐藏头部菜单
    this.fnGetListByType();

    this.fnGetExternalTable();
  },
  methods: {
    // 新增外采
    add() {
      this.addExternalDialog = true;
      this.ExternalTitle = "新增外采";
      this.newCreateBtn = true;
      this.isNew = true;
    },

    changeValue(val) {
      this.ruleForm.ContractType = val;
    },

    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },

    // 0-未提交，1-已提交，2-审核通过，3-退回
    submitReview(row, changeState) {
      this.$confirm("确认提交审核？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          Id: row.id,
          Status: changeState
        };
        AduitOutSourcingManagement(params)
          .then((res) => {
            this.$message({
              message: "提交审核成功！",
              type: "success"
            });
          })
          .catch((err) => {
            console.warn(err);
          });
      });
    },

    submitPass(row, changeState) {
      this.$confirm("确认审核通过？", "提示", {
        confirmButtonText: "确认通过",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          Id: row.id,
          Status: changeState
        };
        AduitOutSourcingManagement(params)
          .then((res) => {
            this.$message({
              message: "审核通过成功！",
              type: "success"
            });
          })
          .catch((err) => {
            console.warn(err);
          });
      });
    },

    submitBack(row, changeState) {
      this.$confirm("确认审核退回？", "提示", {
        confirmButtonText: "确认退回",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          Id: row.id,
          Status: changeState
        };
        AduitOutSourcingManagement(params)
          .then((res) => {
            this.$message({
              message: "审核退回成功！",
              type: "success"
            });
          })
          .catch((err) => {
            console.warn(err);
          });
      });
    },

    // 获取合同性质 Id
    fnGetListByType() {
      let params = {
        dictionaryType: "ContractNature"
      };
      GetListByType(params)
        .then((res) => {
          this.options = res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    onSubmit() {
      this.fnGetExternalTable();
      // console.log("submit!");
    },

    fnGetExternalTable() {
      this.loading = true;
      let params = {
        page: this.pageCurrent,
        pageSize: this.pageLimit,
        ProjectId: this.$route.query.ProjectId,
        ProjectNo: this.$route.query.ProjectNo // 新增/续约项目编号
      };
      GetOutSourcingManagementPageList(params)
        .then((res) => {
          this.tableData = res.data.data;
          this.tableTotalCount = res.data.totalCount;
          this.loading = false;
        })
        .catch((err) => {
          console.warn(err);
        });
    },

    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageCurrent = 1;
      this.pageLimit = val;
      this.fnGetExternalTable();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageCurrent = val;
      this.fnGetExternalTable();
    },

    // 上传事件
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      this.ruleForm.fileList = fileList;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确认移除 ${file.name}？`);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制只能上传 1 个附件，请删除后重新选择`
        // `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
        //   files.length + fileList.length
        // } 个文件`
      );
    },
    fileChange(file, fileList) {
      this.ruleForm.fileList.push(file);
      this.$refs.ruleForm.validateField("fileList");
    },

    // 关闭时 清楚表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.addExternalDialog = false;
    },

    // 提交新的外采合同
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.addLoading = true;
          this.addExternalDialog = false;

          let formData = new FormData();
          formData.append("ProjectId", this.$route.query.ProjectId);
          formData.append("ProjectNo", this.$route.query.ProjectNo);
          formData.append("ContractCode", this.ruleForm.ContractCode);
          formData.append("ContractName", this.ruleForm.ContractName);
          formData.append("ContractPrice", this.ruleForm.ContractPrice);
          formData.append("ActualCost", this.ruleForm.ActualCost);
          formData.append("SupplierName", this.ruleForm.SupplierName);
          formData.append("Payment", this.ruleForm.Payment);
          formData.append("ContractType", this.ruleForm.ContractType);
          formData.append(
            "SignDate",
            moment(this.ruleForm.SignDate).format("YYYY-MM-DD")
          );
          formData.append(
            "ServiceStartDate",
            moment(this.ruleForm.ServiceDate[0]).format("YYYY-MM-DD")
          );
          formData.append(
            "ServiceEndDate",
            moment(this.ruleForm.ServiceDate[1]).format("YYYY-MM-DD")
          );
          formData.append("AfterSale", this.ruleForm.AfterSale);
          formData.append("ProjectManager", this.ruleForm.ProjectManager);
          formData.append("ServiceContent", this.ruleForm.ServiceContent);
          formData.append("Remark", this.ruleForm.Remark);
          formData.append("FilePath_Upload", this.ruleForm.fileList[0].raw);
          AddOutSourcingManagement(formData)
            .then((res) => {
              this.fnGetExternalTable();
            })
            .catch((err) => {
              console.warn(err);
            })
            .finally((res) => {
              this.addLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 编辑验收表单
    submitFormEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addLoading = true;
          this.loading = true;
          this.addExternalDialog = false;

          let formData = new FormData();
          // formData.append("ProjectId", this.$route.query.ProjectId);
          // formData.append("ProjectNo", this.$route.query.ProjectNo);
          formData.append("Id", this.ruleForm.Id);
          formData.append("ContractCode", this.ruleForm.ContractCode);
          formData.append("ContractName", this.ruleForm.ContractName);
          formData.append("ContractPrice", this.ruleForm.ContractPrice);
          formData.append("ActualCost", this.ruleForm.ActualCost);
          formData.append("SupplierName", this.ruleForm.SupplierName);
          formData.append("Payment", this.ruleForm.Payment);
          formData.append("ContractType", this.ruleForm.ContractType);
          formData.append(
            "SignDate",
            moment(this.ruleForm.SignDate).format("YYYY-MM-DD")
          );
          formData.append(
            "ServiceStartDate",
            moment(this.ruleForm.ServiceDate[0]).format("YYYY-MM-DD")
          );
          formData.append(
            "ServiceEndDate",
            moment(this.ruleForm.ServiceDate[1]).format("YYYY-MM-DD")
          );
          formData.append("AfterSale", this.ruleForm.AfterSale);
          formData.append("ProjectManager", this.ruleForm.ProjectManager);
          formData.append("ServiceContent", this.ruleForm.ServiceContent);
          formData.append("Remark", this.ruleForm.Remark);
          formData.append("DAMFilePath", this.ruleForm.DAMFilePath);

          if (this.ruleForm.fileList.length > 0) {
            formData.append("FilePath_Upload", this.ruleForm.fileList[0].raw);
          }

          EditOutSourcingManagement(formData)
            .then((res) => {
              this.fnGetExternalTable();
            })
            .catch((err) => {
              console.warn(err);
            })
            .finally((res) => {
              this.addLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 编辑
    handleEdit(row, index) {
      this.addExternalDialog = true;
      this.ExternalTitle = "编辑外采";
      this.newCreateBtn = false;
      this.isNew = false;

      this.$nextTick(() => {
        this.ruleForm = {
          Id: row.id,
          ContractCode: row.contractCode,
          ContractName: row.contractName,
          ContractPrice: row.contractPrice,
          ActualCost: row.actualCost,
          SupplierName: row.supplierName,
          Payment: row.payment,
          ContractType: row.contractType,
          SignDate: new Date(row.signDate),
          ServiceDate: [
            new Date(row.serviceStartDate),
            new Date(row.serviceEndDate)
          ],
          AfterSale: row.afterSale,
          ProjectManager: row.projectManager,
          ServiceContent: row.serviceContent,
          Remark: row.remark,
          DAMFilePath: row.damFilePath,
          fileList: []
        };
      });
    },

    // 删除外采信息
    handleDel(row, index) {
      let params = {
        id: row.id
      };
      this.$confirm("确认要删除外采信息吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.loading = true;

        DeletetOutSourcingManagement(params)
          .then((res) => {
            this.loading = false;
            this.tableData.splice(index, 1);
            this.$message({
              message: "外采信息删除成功！",
              type: "success"
            });
          })
          .catch((err) => {
            console.warn(err);
            this.loading = false;
          });
      });
    },

    // 付款情况
    changePaymentValue(val) {
      this.PaymentForm.paymentSituation = val;
    },

    submitPaymentForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData();

          formData.append("outSourcingID", this.PaymentForm.outSourcingID);
          formData.append("paymentAmount", this.PaymentForm.paymentAmount);
          formData.append(
            "paymentDate",
            moment(this.PaymentForm.paymentDate).format("YYYY-MM-DD")
          );
          formData.append(
            "paymentSituation",
            this.PaymentForm.paymentSituation
          );
          formData.append("remark", this.PaymentForm.remark);

          const jsonData = {};
          for (const [key, value] of formData.entries()) {
            jsonData[key] = value;
          }
          PaymentAdd(jsonData)
            .then((res) => {
              this.paymentOpen();
              this.PaymentAdd = false;
              this.$message({
                message: "付款信息新增成功！",
                type: "success"
              });
            })
            .catch((err) => {
              console.warn(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    delPaymentInfo(row, index) {
      let params = {
        Id: row.id
      };
      OutSourcingPaymentDelete(params)
        .then((res) => {
          this.paymentTableData.splice(index, 1);
          this.$message({
            message: "付款信息删除成功！",
            type: "success"
          });
        })
        .catch((err) => {
          console.warn(err);
        });
    },

    resetPaymentForm() {
      this.$refs.PaymentForm.resetFields();
      this.PaymentAdd = false;
    },

    // 获取付款信息分页数据
    paymentOpen(row) {
      this.PaymentDialog = true;
      if (row) {
        this.paymentTitle = row.contractName;
        this.PaymentForm.outSourcingID = row.id;
      }

      let params = {
        page: 1,
        pageSize: 10,
        OutSourcingID: this.PaymentForm.outSourcingID
      };
      GetOutSourcingtPaymentPageList(params)
        .then((res) => {
          // console.log(res);
          this.paymentTableData = res.data.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  color: var(--brand);
  &:hover {
    color: var(--text-link);
    text-decoration: underline;
  }
}
.paymentInfo {
  margin-bottom: 40px;
}
.dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>
